<template>
  <div class="collect-wechat">
    <div
      v-if="surveyData.status==='published'"
      class="wechat_wrap"
    >
      <div class="w_title">微信分享</div>
      <div class="w_describe">通过分享链接给您的好友，帮您填写问卷</div>
      <div class="wechat_example">
        <div class="top">
          <div class="e1">
            <div class="e_title"><em>步骤一：</em>微信扫一扫</div>
            <div class="phone_qrocde">
              <img
                class="img_qrcode"
                :src="imgurl"
              />
              <img
                class="img_example"
                src="@/assets/images/survey/collect/iphone1.png"
              />
            </div>
          </div>
          <div class="e2">
            <div class="e_title"><em>步骤二：</em>点击右上角</div>
            <img
              class="img_example"
              src="@/assets/images/survey/collect/iphone2.png"
            />
          </div>
        </div>
        <div class="bottom">
          <div class="e3">
            <div class="e_title"><em>分享一：</em>朋友圈</div>
            <img
              class="img_example"
              src="@/assets/images/survey/collect/iphone3.png"
            />
          </div>
          <div class="e4">
            <div class="e_title"><em>分享二：</em>好友</div>
            <img
              class="img_example"
              src="@/assets/images/survey/collect/iphone4.png"
            />
          </div>
        </div>
      </div>
    </div>
    <no-release
      v-else
      :data="surveyData"
    ></no-release>
  </div>
</template>

<script>
import NoRelease from "./components/no-release";
import qrcode from "qrcode";
export default {
  data() {
    return {
      imgurl: ""
    };
  },
  computed: {
    surveyData() {
      return this.$store.state.survey.surveyBody;
    }
  },
  mounted() {
    this.imgurl = "";
    qrcode
      .toDataURL(`https://yuetu.chingshen.cn/cu/s/${this.$route.params.id}`)
      .then(res => {
        this.imgurl = res;
      });
  },
  components: {
    NoRelease
  }
};
</script>

<style lang="less" scoped>
.collect-wechat {
  padding-top: 20px;
}

.w_title {
  font-size: 30px;
  color: #1d82fc;
}

.w_describe {
  font-size: 18px;
  margin-top: 10px;
}

.wechat_wrap {
  width: 650px;
  margin: 0 auto;
  text-align: center;
}

.wechat_example {
  & > div {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  @media screen and (max-height: 800px) {
    .img_example {
      width: 210px;
    }
  }

  @media screen and (min-height: 800px) {
    .img_example {
      width: 260px;
    }
  }

  .e_title {
    font-size: 14px;
    margin-bottom: 14px;

    em {
      font-style: normal;
      color: #1d82fc;
    }
  }
}

.phone_qrocde {
  position: relative;

  .img_qrcode {
    position: absolute;
  }

  @media screen and (max-height: 800px) {
    .img_qrcode {
      height: 120px;
      width: 120px;
      top: 60px;
      left: 45px;
    }
  }

  @media screen and (min-height: 800px) {
    .img_qrcode {
      height: 130px;
      width: 130px;
      top: 80px;
      left: 64px;
    }
  }
}
</style>
